<template>
  <div class="bg" v-show="show">
    <div class="content-container">
      <div class="title">
        <div class="l">添加水印</div>
        <img @click="cancel" class="r" src="./css/close.png" />
      </div>
      <div class="content">
        <div class="l">
          <ul>
            <li @click="logoIndex = index" v-for="(item,index) in list" :key="item.id">
              <div :class="{back: true, on: logoIndex == index, row: item.width-0 > item.height-0,column: item.width-0 < item.height-0}">
                <img :src="item.url" alt="">
              </div>
              <div class="word">{{item.width}} x {{item.height}}</div>
            </li>
          </ul>
        </div>
        <div class="r">
          <div class="t">水印位置：</div>
          <!-- <div class="select">
            <p @click="selectIndex = 1"><i :class="{on: selectIndex == 1}"></i><span>选择位置</span></p>
            <p @click="selectIndex = 2"><i :class="{on: selectIndex == 2}"></i><span>平铺</span></p>
          </div> -->
          <div class="b">
            <ul>
              <li @click="posIndex = index;changePos(index)" v-for="(item,index) in posList" :key="index" :class="{on: item.select && selectIndex == 1,w: item.select && selectIndex == 2}"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btns">
        <p @click="confirm" class="g">确定</p>
        <p @click="cancel">取消</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import script from '../script'
// import ImageEditor from 'tui-image-editor';

export default {
  name: 'confirm',
  data() {
    return {
      config: {},
      callback: null,
      show: false,
      logoIndex: 0,
      selectIndex: 1,
      posIndex: 0,
      list: [],
      posList: [
        {select: true},
        {select: false},
        {select: false},
        {select: false},
        {select: false},
        {select: false},
        {select: false},
        {select: false},
        {select: false}
      ]
    }
  },
  watch: {
    selectIndex(to) {
      if(to == 1){
        let posList = this.posList;
        posList.forEach(el => {
          el.select = false
        })
        posList[0].select = true;
        this.posList = posList
      }else{
        let posList = this.posList;
        posList.forEach(el => {
          el.select = true
        })
        this.posList = posList
      }
    }
  },
  methods: {
    changePos(index) {
      if(this.selectIndex == 1){
        let posList = this.posList;
        posList.forEach(el => {
          el.select = false
        })
        posList[index].select = true;
        this.posList = posList
      }
    },
    open(callback,config) {
      this.config = config;
      this.callback = callback;
      this.show = true
      this.getList()
    },
    getList() {
      let info = {
        platform_key: this.config
      }

      common.myFetch(apis.imglogos, info).then(res => {
        console.log(res)
        this.list = res.list
      })
    },
    close() {
      this.callback(false)
      this.show = false;
    },
    confirm() {
      let info = {
        watermarkId: this.list[this.logoIndex].id,
        waterPos: this.posIndex-0 + 1
      }
      this.callback(info)
      this.show = false;
    },
    cancel() {
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000003;

    .btns {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 24px;

      p {
        width: 120px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #B9C3C3;
        border-radius: 4px;
        color: #FFFFFF;
        font-size: 14px;
        font-weight: bold;
        user-select: none;
        cursor: pointer;

        &.g {
          background: #41B48C;
          margin-right: 20px;
        }
      }
    }

    .content-container {
      width: 774px;
      height: 512px;
      background: #F9F9F9;
      padding: 20px 30px;
      box-sizing: border-box;

      .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        .l {
          font-size: 24px;
          line-height: 33px;
          color: #323B4B;
          font-weight: bold;
        }

        .r {
          width: 20px;
          height: 20px;
          user-select: none;
          cursor: pointer;
        }
      }

      .content {
        display: flex;
        flex-direction: row;

        .l {
          width: 420px;
          height: 359px;
          background: rgba(185, 195, 195, 0.15);
          border-radius: 4px;
          padding: 0px 2px 0px 30px;
          box-sizing: border-box;

          ul {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            width: 100%;
            height: 100%;
            padding-top: 30px;
            box-sizing: border-box;
            overflow-y: auto;

            &::-webkit-scrollbar {
              width: 4px;
            }
            &::-webkit-scrollbar-thumb {
              background: rgba(#B9C3C3, 0.5);
              border-radius: 4px;
            }

            li {
              display: flex;
              flex-direction: column;
              margin-right: 30px;
              margin-bottom: 30px;

              &:nth-of-type(3n+3) {
                margin-right: 0;
              }

              .back {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100px;
                min-height: 100px;
                max-width: 100px;
                max-height: 100px;
                background-color: rgba(185, 195, 195, 0.15);
                margin-bottom: 10px;
                border: 2px solid transparent;
                box-sizing: border-box;

                &.row {
                  padding: 0 6px;
                  box-sizing: border-box;
                  width: 100%;
                  height: 100%;
                }

                &.column {
                  padding: 0 32px;
                  box-sizing: border-box;
                  width: 100%;
                  height: 100%;
                }

                &.on {
                  border: 2px solid #41B48C;
                  box-sizing: border-box;
                }

                img {
                  width: 100%;
                  height: auto;
                }
              }

              .word {
                font-size: 13px;
                line-height: 18px;
                color: #323B4B;
                text-align: center;
              }
            }
          }
        }

        .r {
          display: flex;
          flex-direction: column;
          margin-left: 30px;

          .t {
            font-size: 14px;
            line-height: 20px;
            color: #323B4B;
            margin-bottom: 17px;
            font-weight: bold;
          }

          .select {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 16px;

            p {
              display: flex;
              flex-direction: row;
              align-items: center;
              user-select: none;
              cursor: pointer;
              margin-right: 40px;
              font-size: 13px;
              line-height: 18px;
              color: #323B4B;

              i {
                display: block;
                width: 16px;
                height: 16px;
                background: rgba(#829191,0.15);
                border-radius: 8px;
                margin-right: 8px;

                &.on {
                  position: relative;
                  background: #41B48C;

                  &:after {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-top: -3px;
                    margin-left: -3px;
                    display: block;
                    content: '';
                    width: 6px;
                    height: 6px;
                    background: #FFFFFF;
                    border-radius: 20px;
                  }
                }
              }
            }
          }

          .b {
            width: 200px;
            height: 200px;
            background: url('./css/bg.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;

            ul {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;

              li {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 66px;
                height: 66px;
                margin-bottom: 1px;
                margin-right: 1px;

                &:hover {
                  background: rgba(255, 255, 255, 0.4);
                }

                &.on {
                  background-image: url('./css/select.png');
                  background-color: rgba(255, 255, 255, 0.4);
                  background-position: center center;
                  background-size: 18px 18px;
                  background-repeat: no-repeat;
                }

                &.w {
                  background-color: rgba(255, 255, 255, 0.4);
                }

                &:nth-of-type(3n+3) {
                  margin-right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
